module.exports = __webpack_public_path__ + "static/image3-b0a046549ce168151bdb8850147a0014.png";